import S from 'common/service/sanctuary';
import { createSelector } from 'reselect';

const getUser$ = ({ user, error }) => (
  error
    ? S.Left(error)
    : S.Right(user ? S.Just(user) : S.Nothing)
);

export const getScope = S.prop('auth');

export const getUser = createSelector(
  getScope,
  getUser$,
);

export const isLoading = createSelector(
  getScope,
  S.prop('loading'),
);

export const isInitLoading = createSelector(
  getScope,
  S.prop('initLoading'),
);

export const getSalt = createSelector(
  getScope,
  ({ salt }) => salt,
);

export const getErrorMaybe = createSelector(
  getScope,
  ({ error }) => (
    error && error.result
      ? S.Just(error)
      : S.Nothing
  ),
);
